import React, { useState } from "react";
import ArrowDown from "../../img/ArrowDown";
import SendArrow from "../../img/SendArrow";
import "./styles.css";

const Dropdown = ({ placeholder, list, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(placeholder);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleSelect = (item) => {
    setSelectedOption(item.name);
    setIsOpen(false);
    if (onSelect) {
      onSelect(item);
    }
  };

  return (
    <div className="dropdown">
      <button onClick={toggleDropdown} className="dropbtn">
        <p>{selectedOption}</p>
        <ArrowDown />
      </button>
      <div className={`dropdown-content ${isOpen ? "show" : ""}`}>
        {list.map((item, index) => (
          <div
            key={index}
            onClick={() => handleSelect(item)}
            className="dropdown-item"
          >
            <div>
              <p className="title">{item.name}</p>
              <p className="subtitle">{item.location}</p>
            </div>
            <SendArrow color="#090D1D" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Dropdown;
